import { render, staticRenderFns } from "./CompanyService.vue?vue&type=template&id=1642d722&scoped=true&"
import script from "./CompanyService.vue?vue&type=script&lang=js&"
export * from "./CompanyService.vue?vue&type=script&lang=js&"
import style0 from "./CompanyService.vue?vue&type=style&index=0&id=1642d722&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642d722",
  null
  
)

export default component.exports